import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { streakService } from '../../services/streakService';

export const useGetMilestoneRewards = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.streak.rewards],
    queryFn: () =>
      streakService.milestoneRewards().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
